export default {
  SICK: "sick",
  INJURY: "injury",
  DEATH: "death",
  RETURN_OF_COSTS: "returnOfCosts",
}
